import { useState, useEffect } from "react"

import { GetMarketplaceLoanPaymentOptionsResponse, LoanOptionsRequest, LoanOptionsRequestFlowType } from "@lib/clients/nelo-api-client"
import { neloApiClient } from "@lib/config-client"

const formatCartTotal = (total: number): number => total * 1000

export const useLoanOptions = (
  cartId: string | null,
  cartTotal: number | null,
  isInitialized: boolean,
  flow: LoanOptionsRequestFlowType = LoanOptionsRequestFlowType.SIGNUP
) => {
  const [loanOptions, setLoanOptions] = useState<GetMarketplaceLoanPaymentOptionsResponse | null>(null)
  const [isLoanOptionLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const getLoanOptions = async () => {
      if (cartId && cartTotal && isInitialized) {
        setIsLoading(true)
        try {
          const loanOptionsRequest: LoanOptionsRequest = {
            amount: {
              amountE5: formatCartTotal(cartTotal),
              currencyCode: "MXN",
            },
            cartId: cartId,
            flow: flow,
          }
          const options = await neloApiClient.getLoanOptions(loanOptionsRequest)
          setLoanOptions(options)
        } catch (err: any) {
          if (err.response?.status === 500) {
            setError(err instanceof Error ? err : new Error("An unknown error occurred"))
          }
          console.error("useLoanOptions.Error getting loan options:", err)
        } finally {
          setIsLoading(false)
        }
      }
    }

    getLoanOptions()
  }, [cartId, cartTotal, isInitialized])

  return { loanOptions, isLoanOptionLoading, error }
}
